// extracted by mini-css-extract-plugin
export default {"root":"TableAction_root__JAQEh","arrow":"TableAction_arrow__M2OMZ"};